import { Link } from 'react-router-dom';
import WhatsAppButton from '../../common/whatsapp';
export default function PrivacyPolicy() {
    const sections = [
        {
            title: 'Quality Assurance Policy',
            items: [
                'All products are manufactured using quality materials and workmanship.',
                'Each product undergoes inspection before dispatch.',
                'We continuously improve our products based on customer feedback and industry requirements.',
            ],
        },
        {
            title: 'Custom Manufacturing Policy',
            items: [
                'Customized products are manufactured according to approved specifications provided by the customer.',
                'Design modifications must be finalized before production begins.',
                'Custom-made products may require additional production time.',
                'Customized orders cannot be returned unless there is a manufacturing defect.',
            ],
        },
        {
            title: 'Order & Payment Policy',
            items: [
                'Orders are processed after confirmation and receipt of the agreed payment.',
                'Bulk and custom orders may require an advance payment before production.',
                'Remaining balance, if applicable, must be cleared before shipment or delivery.',
                'Prices are subject to change without prior notice.',
            ],
        },
        {
            title: 'Shipping & Delivery Policy',
            items: [
                'Delivery timelines vary depending on product availability, order quantity, and customization requirements.',
                'Kinetix will make every effort to dispatch orders within the committed timeframe.',
                'Delivery delays caused by courier services, weather conditions, or other unforeseen circumstances are beyond our control.',
                'Customers are responsible for providing accurate shipping information.',
            ],
        },
        {
            title: 'Return & Replacement Policy',
            items: [
                'Products must be inspected upon delivery.',
                'Any manufacturing defect or shipping damage must be reported within 3 days of receiving the product.',
                'Eligible defective products may be repaired, replaced, or refunded at Kinetix\'s discretion.',
                'Products damaged due to misuse, improper installation, modification, or normal wear and tear are not covered.',
            ],
        },
        {
            title: 'Warranty Policy',
            items: [
                'Warranty coverage applies only to products specifically sold with a warranty.',
                'Warranty covers manufacturing defects under normal use conditions.',
                'Warranty does not cover accidental damage, misuse, unauthorized repairs, or improper handling.',
                'Warranty duration may vary by product category.',
            ],
        },
        {
            title: 'Bulk Order Policy',
            items: [
                'Bulk order pricing is available for institutions, distributors, universities, hospitals, and therapy centers.',
                'Production schedules for bulk orders will be communicated during order confirmation.',
                'Customized bulk orders may require sample approval before mass production.',
            ],
        },
        {
            title: 'Intellectual Property Policy',
            items: [
                'All Kinetix product designs, images, content, branding, and marketing materials remain the property of Kinetix unless otherwise agreed in writing.',
                'Unauthorized reproduction, copying, or resale of proprietary designs is prohibited.',
            ],
        },
        {
            title: 'Privacy Policy',
            items: [
                'Customer information is collected only for order processing, customer support, and business communication.',
                'Personal information will not be sold or shared with third parties except when required for shipping, payment processing, or legal compliance.',
                'We take reasonable measures to protect customer data.',
            ],
        },
        {
            title: 'Product Information Disclaimer',
            items: [
                'Product dimensions and specifications may vary slightly due to manufacturing processes and continuous product improvements.',
                'Product images are for illustration purposes and may differ slightly from the final product.',
                'Customers should verify product suitability for their intended application before purchase.',
            ],
        },
        {
            title: 'Customer Support Policy',
            items: [
                'Our team is committed to providing timely assistance regarding products, orders, and technical inquiries.',
                'Response times may vary during weekends, holidays, and peak business periods.',
                'Customers can contact us through phone, email, or website inquiry forms for support.',
            ],
        },
        {
            title: 'Safety Notice',
            items: [
                'Products should be used under appropriate supervision where required.',
                'Therapy and rehabilitation equipment should be used according to professional recommendations and safety guidelines.',
                'Kinetix is not responsible for injuries resulting from improper use, modification, or misuse of products.',
            ],
        },
        {
            title: 'Contact for Policy Questions',
            items: [
                'If you have any questions regarding our policies, orders, warranty, shipping, or custom manufacturing services, please contact our customer support team for assistance.',
            ],
        },
    ];

    return (
        <main className="pt-24">
            <WhatsAppButton />
            {/* Hero Section – dark blue bg */}
            <section className="w-full bg-[#15415c] py-16 md:py-20">
                <div className="max-w-4xl mx-auto px-6 text-center">
                    <h1 className="text-4xl md:text-6xl font-extrabold text-white tracking-tight leading-tight">
                        Kinetix Policies
                    </h1>
                    <p className="mt-4 text-lg md:text-xl text-white/80 max-w-2xl mx-auto">
                        Our commitments to quality, transparency, and your satisfaction.
                    </p>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-16 md:py-24 bg-surface">
                <div className="max-w-4xl mx-auto px-6">
                    <div className="space-y-10">
                        {sections.map((section, idx) => (
                            <div key={idx}>
                                <h2 className="text-2xl md:text-3xl font-extrabold text-on-surface mb-3">
                                    {section.title}
                                </h2>
                                <ul className="list-disc pl-6 space-y-1.5 text-on-surface-variant leading-relaxed">
                                    {section.items.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>
                                {idx < sections.length - 1 && (
                                    <div className="h-px bg-surface-container-high mt-6" />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </main>
    );
}